module.exports = __webpack_public_path__ + "img/icb-leo-novice-m@3x.39130812.png";